import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import { ConfirmDialog } from 'components/admin/Dialogs';

import ContentEdit, { Actions, Header, Detail, Side } from './ContentEdit';
import {
  InvoiceCards,
  InvoiceCardsSide,
  InvoiceDetail,
  InvoiceFilters,
  InvoiceSide,
} from './Invoices';
import { TooltipTypes } from 'components/admin/Help';

import { getHostingURL } from 'utils';
import { startEditAdmin } from '../../store/actions/admin';
import {
  startEditInvoiceStatuses,
  startRemoveInvoice
} from '../../store/actions/invoices';
import { startAddStorageInvoice } from '../../store/actions/files';
import { startSendInvoice } from '../../store/actions/invoicePreview';
import { generateInvoicePDF } from '../../store/generators';
import { startEditPreview } from '../../store/actions/preview';

const styles = theme => ({
  root: {
  },
  listView: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*4,
    marginLeft: theme.spacing.unit*4,
  },
  detail: {
    marginTop: theme.spacing.unit*2,
    marginLeft: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*4,
  },
  info: {
    marginTop: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
});

class InvoicesPage extends Component{
  constructor(props){
    super(props);

    this.state = { showDelete: false };
  }

  handleCancel = () => {
    this.setState({ showDelete: false });
  }

  handleDelete = () => {
    const {
      invoice,
      startEditAdmin,
      startRemoveInvoice,
    } = this.props;

    startRemoveInvoice(invoice.id);
    startEditAdmin({ invoice: null });

    this.setState({ showDelete: false });
  }

  showDialog = () => this.setState({ showDelete: true });

  render() {
    const {
      classes,
      invoice,
      theme,
      help,
    } = this.props;
    const { showDelete } = this.state;

    return (
      <div>
        <ConfirmDialog
          open={showDelete}
          title="Delete Invoice"
          contentText="This action will delete the invoice. Proceed?"
          handleCancel={this.handleCancel}
          handleOk={this.handleDelete}
        />

        {invoice &&
          <ContentEdit>
            <Actions
              help={help}
              theme={theme}
              actions={createActions(this.props, this.showDialog.bind(this))}
            />
            <Detail theme={theme}>
              <div className={classes.detail}>
                <InvoiceDetail />
              </div>
            </Detail>
            <Side theme={theme}>
              <div className={classes.info}>
                <InvoiceSide />
              </div>
            </Side>
          </ContentEdit>
        }
        {!invoice &&
          <div className={classes.listView}>
            <ContentEdit>
              <Header theme={theme}>
                <InvoiceFilters />
              </Header>
              <Detail theme={theme}>
                <InvoiceCards />
              </Detail>
              <Side theme={theme}>
                <InvoiceCardsSide />
              </Side>
            </ContentEdit>
          </div>
        }
      </div>
    );
  }
}

const createActions = (props, showDialog) => {
  const {
    startEditAdmin,
    startEditPreview,
    invoice,
    invoiceValidation,
    companyInfo,
    client,
    help
  } = props;

  console.log("CREATE ACTIONS INVOICE:", invoice);
  const actions = [
    {
      value: "Print",
      color: "primary",
      type: "print",
      params: { invoice, companyInfo, client },
      handleAction: ({ invoice, companyInfo, client }) => {
        //TODO: find a better way to pass params, for some reason the scope
        //of 'this' resolves to the withStyles HOC
        let url;
        const hostingURL = getHostingURL();
        const generateURL = `${hostingURL}/generateInvoicePDF`;

        let lineItems = [];
        invoice.lineItems.forEach((value, key, map) => lineItems.push({ id: key, ...value }));

        const data = {
          "company": {
            "name": companyInfo.companyName,
            "phone": companyInfo.phone,
            "email": companyInfo.email,
            "address": companyInfo.address,
          },
          "client": {
            "name": client.fullName,
            "address": {
              "street": client.address,
              "city": client.city,
              "province": client.province,
              "country": client.country,
              "postalCode": client.postalCode,
            }
          },
          "invoice": {
            "invoiceNumber": invoice.invoiceNumber,
            "invoiceDate": invoice.invoiceDate,
            "dueDate": invoice.dueDate,
            "gst": invoice.gst.toFixed(2),
            "pst": invoice.pst.toFixed(2),
            "total": invoice.total.toFixed(2),
            "grandTotal": invoice.grandTotal.toFixed(2),
            lineItems,
          },
        }

        const invoiceData = {
          companyName: companyInfo.companyName,
          clientName: client.fullName,
          invoiceNumber: invoice.invoiceNumber,
          total: invoice.total.toFixed(2),
          grandTotal: invoice.grandTotal.toFixed(2),
          gst: invoice.gst.toFixed(2),
          pst: invoice.pst.toFixed(2),
          balance: invoice.balance.toFixed(2),
          lineItems,
        }
        //const companyInfo = {}
        const clientData = {}

        fetch(generateURL, {
          mode: 'cors',
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            data,
            token: "LaST18dswfD37VCwVjSsgiselDIDqwwq18iXTvRv"
          })
        })
          .then(response => response.json())
          .then(base64 => {

            console.log("RESULT:", base64);
            // decode base64 string, remove space for IE compatibility
            //NOTE: do this another way, as atob might have compatibility issues???
            //also, cleaner option: Uint8Array.from(atob(base64_string), c => c.charCodeAt(0))
            var binary = atob(base64.pdfDoc.replace(/\s/g, ''));
            var len = binary.length;
            var buffer = new ArrayBuffer(len);
            var view = new Uint8Array(buffer);
            for (var i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }

            // create the blob object with content-type "application/pdf"
            var blob = new Blob( [view], { type: "application/pdf" });
            console.log("BLOB", blob);

            url = URL.createObjectURL(blob);
            // console.log("URL:", url);
            window.open(url, '_blank');
            //return url;
          })

        // const pdf = generateInvoicePDF(invoice, companyInfo, client);
        // pdf.print();
        // const tab = window.open();
        // tab.document.body.innerHTML = "LOADING...";
        // var docDefinition = { content: '2This is an sample PDF printed with pdfMake' };
        // pdfMake.vfs = font.pdfMake.vfs
        // const pdf = pdfMake.createPdf(docDefinition);
        // pdf.print();
        // pdf.getBlob((blob) => {
        //   startAddStorageInvoice(invoice.id, blob)
        //     .then(result => {
        //       tab.location.href = result.downloadURL;
        //     });
        // });
      },
    },
    {
      value: "Send",
      color: "primary",
      tooltipType: TooltipTypes.INVOICE_PREVIEW_SEND,
      tooltipPlacement: "bottom",
      handleAction: ({ defaultEmail }) => {
        const pdf = generateInvoicePDF(invoice, companyInfo, client);
        const toEmail = defaultEmail ? defaultEmail : client.email;

        pdf.getBlob(blob => {
          startEditPreview({
            show: true,
            data: {
              title: "Send Invoice",
              type: "send-invoice",
              invoice: invoice,
              blob: blob,
              pdf: pdf,
              toEmail,
              client,
            }
          });
        })

      //   const pdf = generateInvoicePDF(invoice, companyInfo, client);
      //   pdf.getBlob((blob) => {
      //     startAddStorageInvoice(invoice.id, blob)
      //       .then(() => {
      //         startSendInvoice({
      //           invoiceID: invoice.id,
      //           invoiceNumber: invoice.invoiceNumber,
      //           grandTotal: invoice.grandTotal.toFixed(2),
      //           balance: invoice.balance.toFixed(2),
      //           recipient: "mjmoore@gmail.com",
      //           clientName: "Test ClientName",
      //           companyName: "Company Name"
      //         });
      //         startEditInvoiceStatuses(invoice.id, { sent: true });
      //       })
      //   });
      },
    },
    {
      value: "Delete",
      color: "primary",
      handleAction: () => {
        showDialog();
      },
    },
    {
      type: "divider",
    },
    {
      value: "Close",
      color: "default",
      handleAction: () => {
        if (invoiceValidation.isInvalid) {
          startEditAdmin({ invoice: { ...invoice, showValidation: true }});
        } else {
          startEditAdmin({ invoice: null });
        }
      },
    },
  ];

  return actions;
}

InvoicesPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const adminInvoice = state.adminState.invoice;
  const invoice = adminInvoice && state.invoicesState.find(invoice => invoice.id === state.adminState.invoice.id);
  const clients = state.clientsState;
  const account = state.accountState ? state.accountState : {};
  const profile = (account.user && account.user.profile && account.user.profile) ? account.user.profile : {};
  const organization = account.organizations[0] ? account.organizations[0] : {};
  const about = organization.about ? organization.about : {};

  const address = {
    street: about.phone ? about.phone : "",
    city: about.city ? about.city : "",
    province: about.province ? about.province : "",
    country: about.country ? about.country : "",
    postalCode: about.postalCode ? about.postalCode : "",
  };

  let client;
  let invoiceValidation = {};
  if (invoice) {
    client = clients.find((client) => client.id === invoice.clientId);
    invoiceValidation = state.validation.invoices.find(item => item.id === invoice.id);
  }

  //const companyInfo = state.companyInfoState;
  const companyInfo = {
    companyName: about.name ? about.name : "",
    companyPhone: about.phone ? about.phone : "",
    companyEmail: profile.email ? profile.email : "",
    address,
  }
  return ({
    invoice,
    companyInfo,
    client: client ? client : {},
    invoiceValidation,
    help: state.help,
  });
};


const mapDispatchToProps = {
  startEditAdmin,
  startRemoveInvoice,
  startEditInvoiceStatuses,
  startAddStorageInvoice,
  startSendInvoice,
  startEditPreview
};

export default compose(
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),
)(InvoicesPage);



// WEBPACK FOOTER //
// ./src/components/admin/InvoicesPage.jsx